module.exports = __webpack_public_path__ + "img/sec2_02.8e8f1935.png";